import React from "react";
import Typography from "@mui/material/Typography";
const MeetingRoomBooking =()=>{
    return(
        <Typography>MeetingRoomBooking</Typography>

    )
};
export default MeetingRoomBooking;